import { faMessage } from "@fortawesome/free-solid-svg-icons"
import Card from "../Card/Card"
import type { ListItem } from "../List/List"
import { MessageList } from "../MessageList/MessageList"
import { AnimationTypes } from "../Animate/Animate"

interface TimeClockCardGridProps {
  items: ListItem[]
  emptyLabel: string
  onSelect?: (id: number) => void
  descriptionKey: string
}

export const TimeClockCardGrid: React.FC<TimeClockCardGridProps> = ({
  items,
  emptyLabel,
  onSelect,
  descriptionKey,
}) => {
  if (items.length === 0) {
    return (
      <MessageList
        color="#ffffff"
        message={emptyLabel}
        icon={faMessage}
        animationTypes={AnimationTypes.slideUpIn}
        animationDuration="1s"
      />
    )
  }

  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => (
        <Card
          key={item.id}
          keyData={item.id}
          isDisable={item.isDisable}
          children={item.children}
          body={item.body}
          linkImage={item.linkImage}
          onClick={(event) => {
            event.stopPropagation()
            onSelect?.(item.id)
          }}
          descriptionKey={descriptionKey}
        />
      ))}
    </div>
  )
}
